let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8gwll")).then(() => parcelRequire('6jzw4'));